import * as React from "react"
import cls from "classnames"
import {graphql, HeadFC, useStaticQuery} from "gatsby"
import {Layout} from "src/components/organisms/Layout"
import {Promo} from "src/components/organisms/Promo";

import {formItems} from "data/common/formsData";
import {products} from "data/alpaquita/data/productsData";
import {ContactsForm} from "src/components/organisms/ContactsForm";
import {ProductsGrid} from "src/components/organisms/ProductsGrid";
import {Props as CardProps} from "src/components/organisms/ProductCard";
import * as styles from "src/components/organisms/Advantages/styles.module.scss";
import * as formStyles from 'src/data/common/forms.module.scss';
import {Advantages} from "src/components/organisms/Advantages";

import stack from "src/images/pages/alpaquita/stack.svg";
import team from "src/images/pages/alpaquita/team.svg";
import message from "src/images/pages/alpaquita/message.svg";

import {StaticImage} from "gatsby-plugin-image";
import * as supportStyles from "src/styles/pages/support-login/support-login.module.scss";
import {BackgroundImage} from "src/components/organisms/BackgroundImage";
import {PlansTable, TableData} from "src/components/organisms/PlansTable";
import {BlockHeading} from "src/components/organisms/BlockHeading";
import Img from "gatsby-image";
import {gatsbyImagePlaceholderStyle} from "util/commons";
import {FormBannerCloudCosts} from "src/components/organisms/Banners/v4/banners";
import {RoadmapTable} from "src/components/organisms/RoadmapTable";
import {IdHeading} from "components/organisms/IdHeading";
import {useEffect} from "react";
import {appendLeadInfoScript} from "util/ga/gaHelpers";

type Item = CardProps & { id: number }

export const cards3: Item[] = [
    {
        id: 1,
        icon: team,
        title: 'Lean on Experts',
        description: 'BellSoft’s team leverages their extensive knowledge in Java™ and cloud application deployment. They stand ready to assist in containerizing your project and swiftly resolving any issues related to the Java™ code or Linux.',
        className: styles.card,
        childrenClassNames: {
            icon: supportStyles.icon,
            title: 'color-white',
            description: 'color-gray',
        },
    },
    {
        id: 2,
        icon: message,
        title: 'Guaranteed Safety',
        description: "With our ongoing support in deploying, running, and managing cloud applications, we assure the security and reliability of Alpaquita-based solutions.",
        className: cls(styles.card, supportStyles.card),
        childrenClassNames: {
            icon: supportStyles.icon,
            title: 'color-white',
            description: 'color-gray',
        },
    },
    {
        id: 3,
        icon: stack,
        title: 'Flexible and Fair Pricing',
        description: "We offer custom and cost-effective support plans that cover a variety of platforms, giving you the flexibility to choose the plan that works best for your company.",
        className: styles.card,
        childrenClassNames: {
            icon: supportStyles.icon,
            title: 'color-white'
        },
    }
]

const IndexPage = () => {

    const productImageQuery = useStaticQuery(
        graphql`
            query {
                promoMobileImage: file(absolutePath: {regex: "/.*images\\/pages\\/alpaquita\\/promo-mobile.png/"}) {
                  childImageSharp {
                    fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                promoTabletImage: file(
                  absolutePath: {regex: "/.*images\\/pages\\/alpaquita\\/promo-tablet.png/"}
                ) {
                  childImageSharp {
                    fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                promoDesktopImage: file(
                  absolutePath: {regex: "/.*images\\/pages\\/alpaquita\\/promo-desktop.png/"}
                ) {
                  childImageSharp {
                    fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                liberica: file(relativePath: { eq: "pages/support/liberica-desktop.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                libericaMobile: file(relativePath: { eq: "pages/support/liberica-mobile.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                libericaTablet: file(relativePath: { eq: "pages/support/liberica-tablet.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                alpaquita: file(relativePath: { eq: "pages/support/alpaquita-desktop.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                alpaquitaMobile: file(relativePath: { eq: "pages/support/alpaquita-mobile.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                alpaquitaTablet: file(relativePath: { eq: "pages/support/alpaquita-tablet.png" }) {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 90,
                            layout: FIXED
                        )
                    }
                }
                  allFormsJson(filter: {fields: {idSelector: {in: ["popup-request-alpaquita-standard-support-quote", "popup-request-alpaquita-premium-support-quote"]}}}) {
                    nodes {
                      title
                      details
                      successDetails
                      successTitle
                      formId
                      eventAction
                      fields {
                        hashedIdSelector
                        idSelector
                      }
                      items {
                        gridColumn
                        name
                        placeholder
                        required
                        type
                      }
                      controls {
                        terms {
                          name
                        }
                        button {
                          caption
                        }
                      }
                    }
                  }
            }
        `
    );

    const pricingProps = {
        modal1: "#popup-request-alpaquita-standard-support-quote",
        modal2: "#popup-request-alpaquita-premium-support-quote"
    }

    const tableData: TableData = {
        thead: [
            [
                {type: "", text: "Alpaquita Enterprise: What’s included?"},
                {type: "", text: "Standard"},
                {type: "", text: "Premium"}
            ]
        ],
        tbody: [
            [
                {type: "", text: "Alpaquita OS"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "", text: "Docker containers"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "group-heading", text: "Releases & Updates"},
                {type: "spacer", text: ""},
                {type: "spacer", text: ""}
            ],
            [
                {type: "", text: "Regular updates & security patches"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "", text: "Off-cycle updates and bug fixes"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "", text: "Emergency patches"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "group-heading", text: "Support hours and SLA for first response"},
                {type: "spacer", text: ""},
                {type: "spacer", text: ""}
            ],
            [
                {type: "", text: "Support hours"},
                {type: "", text: <span>Business hours</span>},
                {type: "", text: <span className={"color-green"}>24/7/365</span>}
            ],
            [
                {type: "", text: "SLA for first response"},
                {type: "", text: <span>next business day</span>},
                {type: "", text: <span className={"color-green"}>An initial response <br/>within one hour</span>}
            ],
            [
                {type: "", text: "Initial consultation with a Bellsoft Java expert"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "", text: "Dedicated Java expert exclusively assigned to your project"},
                {type: "", text: <i className={"bs-icon icon-minus m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "group-heading", text: "Channels"},
                {type: "spacer", text: ""},
                {type: "spacer", text: ""}
            ],
            [
                {type: "", text: "Email and web support"},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "", text: "Phone support"},
                {type: "", text: <i className={"bs-icon icon-minus m"}></i>},
                {type: "", text: <i className={"bs-icon icon-check icon-green m"}></i>}
            ],
            [
                {type: "group-heading", text: "Pricing"},
                {type: "", text: <span>On request</span>},
                {type: "", text: <span className={"color-green"}>On request</span>}
            ],
        ]
    }

    const promoBackground = (className: string) => {
        const sources = [
            {
                ...productImageQuery.promoDesktopImage.childImageSharp.fluid,
                media: `(min-width: 1024px)`,
            },
            {
                ...productImageQuery.promoTabletImage.childImageSharp.fluid,
                media: `(min-width: 768px)`,
            },
            productImageQuery.promoMobileImage.childImageSharp.fluid,
        ]

        return (
            <Img className={className} fluid={sources} placeholderStyle={gatsbyImagePlaceholderStyle}/>
        )
    }

    return (
        <Layout
            button={{
                className: 'bg-green color-dark'
            }}
            forms={productImageQuery.allFormsJson.nodes}
            popupType="alpaquita"
        >

            <Promo
                className="bg-black"
                backgroundElement={promoBackground}
                childrenClassNames={
                    {
                        content: supportStyles.promoContent
                    }
                }
                title={"Technical Support for Alpaquita Linux"}
                subtitle="Secure, supported, and managed open source for enterprises"
                description="Focus on deploying infrastructure or services while relishing the utmost level of security"
                buttons={[
                    {
                        caption: 'Get a Quote',
                        href: '#contacts-form',
                        className: 'bg-green color-dark'
                    }
                ]}
                form={<form id="login-form" action="/support/authenticate/" method="POST"
                            encType="application/x-www-form-urlencoded" data-hs-cf-bound="true">
                    <input className={cls(supportStyles.loginbtn, "bg-white color-dark")} type="submit" name="login"
                           value="Login"/>
                </form>}
            />

            <div className={supportStyles.support_login_page}>
                <a id={"pricing"}></a>
                <Advantages items={cards3} className={supportStyles.container}/>


                <BackgroundImage alt={""} desktop={
                    <StaticImage quality={85} src={"../../images/pages/support/alpaquita-table-bg3.png"}
                                 alt={""}></StaticImage>
                }>
                    <BlockHeading text={"Alpaquita Linux Commercial\nSupport Plans & Pricing"}
                                  className={supportStyles.tableWrapper}>
                        <div className={"bs-flex-container l"}>
                            <p className={"p-2"} style={{textAlign: "center"}}>Alpaquita Linux stands out as a secure and high-performing cloud solution tailored to Java applications. Select the plan that suits your needs perfectly.</p>
                        </div>

                        <PlansTable className={supportStyles.plansTable} pricingProps={pricingProps}
                                    childrenClassNames={{}}
                                    data={tableData} theme={"green"}></PlansTable>

                        <div className={"bs-flex-container l"}>
                            <FormBannerCloudCosts isLarge={true}></FormBannerCloudCosts>
                        </div>
                    </BlockHeading>
                </BackgroundImage>

                <a id={"roadmap"}></a>
                <div className={"bg-white"}>
                    <BackgroundImage alt={""} desktop={
                        <StaticImage quality={85} src={"../../images/pages/support/alpaquita-small-table-bg.png"}
                                     alt={""}></StaticImage>
                    }>
                        <BlockHeading className={"t"} text={"Support Roadmap for Alpaquita Linux"}
                                      headingAlign={"left"}>
                            <div className={"bs-flex-container l"}>
                                <RoadmapTable></RoadmapTable>
                            </div>
                        </BlockHeading>
                    </BackgroundImage>
                </div>

                <div className={cls(supportStyles.support_plans)} style={{backgroundColor: "#f9f9f9"}}>
                    <IdHeading headingLevel={2}>Why Alpaquita Linux?</IdHeading>
                    <ProductsGrid
                        className={supportStyles.productsGrid}
                        columns={2}
                        items={products}
                        sliderSettings={{
                            centerMode: false,
                            dotsClass: cls('slick-dots', 'color-cyan', supportStyles.slick_dots)
                        }}
                    />
                </div>
            </div>

            <a id="contacts-form"></a>

            <BackgroundImage
                desktop={<StaticImage src={"../../images/pages/alpaquita/form-desktop.png"} alt={"test"}/>}
                tablet={<StaticImage src={"../../images/pages/alpaquita/form-tablet.png"} alt={"test"}/>}
                mobile={<StaticImage src={"../../images/pages/alpaquita/form-mobile.png"} alt={"test"}/>}
                alt={"Contact Form Background"}
            >
                <ContactsForm
                    details="Consult with Our Linux Expert"
                    title="Discover How Alpaquita Containers Can Enhance Your Microservice"

                    successDetails="Thank you for your interest in our company"
                    successTitle="We will send the guidance on migrating Alpaquita Linux to the specified email"
                    form={formItems} classNames={{ input: {container: formStyles.alpaquitaForm}}}
                />
            </BackgroundImage>
        </Layout>
    )
}

export default IndexPage

export const Head: HeadFC = () =>
    <>
        <title>Technical Support for Alpaquita Linux | Bellsoft</title>
        <meta name="description"
              content="With the BellSoft support team, you can focus on deploying infrastructure or services with  the utmost level of security in your containerized project."/>
        <meta name="keywords"
              content="BellSoft, Java Support, OpenJDK Support, Java SE Support, Premium Support, Java Cloud, Java VMs, Java Docker, Java Long Term Support"/>
    </>
